(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RunnerDialogController', RunnerDialogController);

    RunnerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'DataUtils', 'entity', 'Runner', 'User', 'Membership', 'Score', 'RunnerRaceResume', 'Address', 'SocialMedia'];

    function RunnerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, DataUtils, entity, Runner, User, Membership, Score, RunnerRaceResume, Address, SocialMedia) {
        var vm = this;

        vm.runner = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.users = User.query();
        vm.memberships = Membership.query({filter: 'runner-is-null'});
        $q.all([vm.runner.$promise, vm.memberships.$promise]).then(function() {
            if (!vm.runner.memberShip || !vm.runner.memberShip.id) {
                return $q.reject();
            }
            return Membership.get({id : vm.runner.memberShip.id}).$promise;
        }).then(function(memberShip) {
            vm.memberships.push(memberShip);
        });
        vm.scores = Score.query({filter: 'runner-is-null'});
        $q.all([vm.runner.$promise, vm.scores.$promise]).then(function() {
            if (!vm.runner.score || !vm.runner.score.id) {
                return $q.reject();
            }
            return Score.get({id : vm.runner.score.id}).$promise;
        }).then(function(score) {
            vm.scores.push(score);
        });
        vm.runnerraceresumes = RunnerRaceResume.query();
        vm.addresses = Address.query();
        vm.socialmedias = SocialMedia.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.runner.id !== null) {
                Runner.update(vm.runner, onSaveSuccess, onSaveError);
            } else {
                Runner.save(vm.runner, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('liverunApp:runnerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setProfilePhoto = function ($file, runner) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        runner.profilePhoto = base64Data;
                        runner.profilePhotoContentType = $file.type;
                    });
                });
            }
        };
        vm.datePickerOpenStatus.birthday = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
